export enum ScaleTypes {
  SEQUENTIAL = 'sequential'
}

export interface DefaultChartData {
  value: number;
  label: string;
}

export interface D3Event<T= any> {
  d: T;
  i: number;
  elements: SVGPathElement[] | SVGRectElement[] | ArrayLike<any>;
}
